var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 225,
    viewBox: "0 0 168 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.845 126.568H87.7654V125.409C87.8336 118.761 90.22 115.659 95.6064 112.42C101.981 108.636 106.14 103.625 106.14 95.6136C106.14 83.6818 96.5268 76.7273 82.9927 76.7273C70.6177 76.7273 60.5268 83.2045 60.22 96.8409H74.1291C74.3336 91.2841 78.4586 88.3182 82.9245 88.3182C87.5268 88.3182 91.2427 91.3864 91.2427 96.125C91.2427 100.591 88.0041 103.557 83.8109 106.216C78.0836 109.83 74.8791 113.477 74.845 125.409V126.568ZM81.5609 148.386C85.9245 148.386 89.7086 144.739 89.7427 140.205C89.7086 135.739 85.9245 132.091 81.5609 132.091C77.0609 132.091 73.345 135.739 73.3791 140.205C73.345 144.739 77.0609 148.386 81.5609 148.386Z",
    fill: "#6366F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1207 1.5V32.7054C57.1207 43.7511 48.1663 52.7054 37.1206 52.7054H1.57227M57.1207 1.5H145.572C156.618 1.5 165.572 10.4543 165.572 21.5V203.5C165.572 214.546 156.618 223.5 145.572 223.5H21.5723C10.5266 223.5 1.57227 214.546 1.57227 203.5V52.7054M57.1207 1.5L1.57227 52.7054",
    stroke: "#A3A3C2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateEmptyState);
export default __webpack_public_path__ + "static/media/template-empty-state.d575fe540b8d7e71908ae1844d5afb69.svg";
export { ForwardRef as ReactComponent };